export default __webpack_public_path__ + "static/media/img-digital-sticker-vertical.f2baa9b4.jpg";